// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3neF0","content":"Consent_content__2astP","footer":"Consent_footer__2wNBy"};